import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Info } from 'lucide-react';
import styles from './HelpTooltip.module.css';

interface HelpTooltipProps {
  title: string;
  description: string;
  tip?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ 
  title, 
  description, 
  tip,
  position = 'top',
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={`${styles.container} ${className}`}>
      <button
        className={styles.trigger}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
        type="button"
      >
        <Info size={14} />
      </button>

      <AnimatePresence>
        {isVisible && (
          <motion.div
            className={`${styles.tooltip} ${styles[`tooltip${position.charAt(0).toUpperCase() + position.slice(1)}`]}`}
            initial={{ opacity: 0, scale: 0.8, y: position === 'top' ? 10 : -10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: position === 'top' ? 10 : -10 }}
            transition={{ duration: 0.2 }}
          >
            <div className={`${styles.arrow} ${styles[`arrow${position.charAt(0).toUpperCase() + position.slice(1)}`]}`} />
            
            <div className={styles.content}>
              <h4 className={styles.title}>{title}</h4>
              <p className={styles.description}>{description}</p>
              
              {tip && (
                <div className={styles.tip}>
                  <span className={styles.tipLabel}>💡 Dica:</span>
                  <span className={styles.tipText}>{tip}</span>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HelpTooltip;
